type DataLayerObject = {
  push(...items: Record<string, unknown>[]): number;
  some(fn: (item: Record<string, unknown>) => boolean): boolean;
  [key: string | symbol]: unknown;
};

declare global {
  interface Window {
    dataLayer?: DataLayerObject;
  }
}

const WRAPPED = Symbol.for('ds.dataLayerWrapped');
let initialized = false;

function wrapPush(dl: DataLayerObject) {
  if (dl[WRAPPED]) {
    return;
  }

  const originalPush = dl.push.bind(dl);
  dl.push = (...args: Record<string, unknown>[]) => {
    const result = originalPush(...args);
    for (const item of args) {
      window.dispatchEvent(new CustomEvent('datalayerpush', { detail: item }));
    }
    return result;
  };

  dl[WRAPPED] = true;
}

export function initDataLayer() {
  if (initialized || typeof window === 'undefined') {
    return;
  }
  initialized = true;

  let current = window.dataLayer;
  if (!current) {
    current = [] as unknown as DataLayerObject;
    window.dataLayer = current;
  }
  wrapPush(current);

  try {
    Object.defineProperty(window, 'dataLayer', {
      configurable: true,
      enumerable: true,
      get: () => current,
      set(next: DataLayerObject) {
        current = next;
        if (current) {
          wrapPush(current);
        }
      },
    });
  } catch {
    // Non-configurable - wrap already applied above
  }
}
